/**
 * @description
 * Objeto Comments
 */

export class Comments {
    public id:number = null;
    public dboid: string;
    public name: string;
    public text: string;
    public nif: string;
    public email: string;
    public created_at: Date;
    public upcated_at: Date;
    public admin:number=null;
  
    constructor() {}
}